import React from "react";

function TabellaFitnessNuova() {
    return(
        <div className="table-container">
            <table className="table text-center m-auto" style={{width: "90%"}}>
                <thead>
                <tr>
                    <th className="" scope="col">Lun</th>
                    <th className="" scope="col">Mar</th>
                    <th className="" scope="col">Mer</th>
                    <th className="" scope="col">Gio</th>
                    <th className="" scope="col">Ven</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="data-cell">
                        9:00 - 10:00 <br/> <a href="#infoFitness" style={{color: "black"}}>Total Body</a>
                    </td>
                    <td className="data-cell">
                        9:00 - 10:00 <br/> <a href="#infoFitness" style={{color: "black"}}>Stretching Pilates</a>
                    </td>
                    <td className="data-cell">
                        9:00 - 10:00 <br/> <a href="#infoFitness" style={{color: "black"}}>Up Body</a>
                    </td>
                    <td className="data-cell">
                        9:00 - 10:00 <br/> <a href="#infoFitness" style={{color: "black"}}>Postural Pilates</a>
                    </td>
                    <td className="data-cell">
                        9:00 - 10:00 <br/> <a href="#infoFitness" style={{color: "black"}}>Pilates</a>
                    </td>
                </tr>
                <tr>
                    <td className="data-cell">
                        10:00 - 11:00 <br/> <a href="#infoFitness" style={{color: "black"}}>Stretching</a>
                    </td>
                    <td className="data-cell">
                        10:00 -11:00 <br/> <a href="#infoFitness" style={{color: "black"}}>Stretching Pilates</a>
                    </td>
                    <td className="data-cell">
                        10:00 -11:00 <br/> <a href="#infoFitness" style={{color: "black"}}>Leg Crash</a>
                    </td>
                    <td className="data-cell">
                        10:00 -11:00 <br/> <a href="#infoFitness" style={{color: "black"}}>Postural Pilates</a>
                    </td>
                    <td className="data-cell">
                        10:00 -11:00 <br/> <a href="#infoFitness" style={{color: "black"}}>Functional Training</a>
                    </td>
                </tr>
                <tr>
                    <td className="data-cell">
                        12:40 - 13:30  <br/> <a href="#infoFitness" style={{color: "black"}}>Pilates</a>
                    </td>
                    <td className="data-cell">
                        12:40 - 13:30 <br/> <a href="#infoFitness" style={{color: "black"}}>GAG</a>
                    </td>
                    <td className="data-cell">
                        12:00 - 13:00 <br/> <a href="#infoFitness" style={{color: "black"}}>Hatha Yoga</a>
                    </td>
                    <td className="data-cell">
                        12:40 - 13:30 <br/> <a href="#infoFitness" style={{color: "black"}}>Functional Training</a>
                    </td>
                    <td className="data-cell"> </td>
                </tr>
                <tr>
                    <td className="data-cell">
                        13:30 - 14:20  <br/> <a href="#infoFitness" style={{color: "black"}}>Total Body</a>
                    </td>
                    <td className="data-cell">
                        13:30 - 14:20 <br/> <a href="#infoFitness" style={{color: "black"}}>Stretching Mobility</a>
                    </td>
                    <td className="data-cell"></td>
                    <td className="data-cell">
                        13:30 - 14:20 <br/> <a href="#infoFitness" style={{color: "black"}}>Pilates</a>
                    </td>
                    <td className="data-cell">
                        13:00 - 14:00 <br/> <a href="#infoFitness" style={{color: "black"}}>Hatha Yoga</a>
                    </td>
                </tr>
                <tr>
                    <td className="data-cell">
                        19:00 - 19:50  <br/> <a href="#infoFitness" style={{color: "black"}}>Fit Boxe</a>
                    </td>
                    <td className="data-cell">
                        18:50 - 19:40 <br/> <a href="#infoFitness" style={{color: "black"}}>Functional Training</a>
                    </td>
                    <td className="data-cell">
                        19:00 - 19:50 <br/> <a href="#infoFitness" style={{color: "black"}}>Stretching Pilates</a>
                    </td>
                    <td className="data-cell">
                        19:00 - 19:50 <br/> <a href="#infoFitness" style={{color: "black"}}>Abdominals</a>
                    </td>
                    <td className="data-cell">
                        19:00 - 19:50 <br/> <a href="#infoFitness" style={{color: "black"}}>Functional Training</a>
                    </td>
                </tr>
                <tr>
                    <td className="data-cell">
                        19:50 - 20:40  <br/> <a href="#infoFitness" style={{color: "black"}}>Functional Training</a>
                    </td>
                    <td className="data-cell">
                        19:40 - 20:30 <br/> <a href="#infoFitness" style={{color: "black"}}>Pilates</a>
                    </td>
                    <td className="data-cell">
                        20:00 - 21:00 <br/> <a href="#infoFitness" style={{color: "black"}}>Hatha Yoga</a>
                    </td>
                    <td className="data-cell">
                        19:50 - 20:40 <br/> <a href="#infoFitness" style={{color: "black"}}>Fit Boxe</a>
                    </td>
                    <td className="data-cell">
                        19:50 - 20:40 <br/> <a href="#infoFitness" style={{color: "black"}}>Pilates</a>
                    </td>
                </tr>

                </tbody>
            </table>
        </div>
    )
}

export default TabellaFitnessNuova